module.exports = __webpack_public_path__ + "788b18efd3bdd8dc41db5d975e3559f0.png";